import axios from "axios";

function initialState() {
    return {
        segments: [],
        segmentOptions: [],
    };
}

export default {
    namespaced: true,
    state: initialState,

    getters: {
        segments: (state) => state.segments,
    },

    mutations: {
        UPDATE_SEGMENTS(state, val) {
            state.segment = val;
        },
        setSegmentOptions: (state, value) => {
            state.segmentOptions = value;
        },
    },

    actions: {
        listSegments() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/api/Segments")
                    .then((response) => resolve(response))
                    .catch((error) => reject(error.response));
            });
        },
        getSegmentOptions: ({ commit }) => {
            axios
                .get("/api/Segments/ComboOptions")
                .then(({ data }) => {
                    commit("setSegmentOptions", data.data);
                });
        },
    },
};
